module.exports = __webpack_public_path__ + "img/profile_img02.9c0c3ca6.jpg";